import { ShoppingCart } from "lucide-react";
import { PageHeader } from "@/components/ranger/PageHeader";
import { CrudTable, itemsFmt } from "@/components/ranger/Crud";
import { KitBuilder } from "@/components/ranger/KitBuilder";
import { Orders } from "@/components/ranger/Orders";
import { useAuth } from "@/context/AuthContext";

const base = (priceDefault, cooldownDefault) => [
  { key: "name", label: "Name", default: "" },
  { key: "price", label: "Price", type: "number", default: priceDefault },
  { key: "description", label: "Description", type: "textarea", default: "" },
  { key: "items", label: "Items (one per line: shortname amount)", type: "items", hint: "Rust item shortnames, e.g. wood 1000, rifle.ak 1" },
  { key: "cooldown_minutes", label: "Cooldown per player (minutes)", type: "number", default: cooldownDefault },
  { key: "enabled", label: "Enabled", type: "switch", default: true },
];
const cols = [["name", "Name"], ["price", "Price"], ["items", "Contents", itemsFmt], ["cooldown_minutes", "Cooldown (min)"], ["enabled", "Enabled", (v) => (v ? "Yes" : "No")]];

const Store = ({ kind }) => {
  const { active } = useAuth();
  const shop = kind === "shop";
  return (
    <div>
      <PageHeader eyebrow="Economy" title={shop ? "Shop" : "Kits"} description={shop ? "Items players can buy with currency from the player portal." : "Build kits slot by slot. Rotate or randomise item sets, lock kits to VIP Discord roles and give roles shorter cooldowns. Price 0 = free."} />
      {shop ? <CrudTable cid={active.id} path="shop-items" title="Shop item" icon={ShoppingCart}
        fields={base(100, 0)} columns={cols} emptyText="Add your first shop item." /> : <KitBuilder cid={active.id} />}
      <Orders cid={active.id} kind={kind} />
    </div>
  );
};

export const Shop = () => <Store kind="shop" />;
export const Kits = () => <Store kind="kit" />;
